import React, { useEffect, useState } from "react";
import { getChatUserImage } from "./userList";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { backendUrl } from "../../constants";
import { Accordion } from "react-bootstrap";
import { chatMediaGetAction } from "../../actions/chat";
import { useNavigate } from "react-router";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import ChatImagePreviewer from "../../components/ChatImagePreviewer/ChatImagePreviewer";
import ManagePeople from "../../components/message/ManagePeople";
import { getName } from "./messageDetail";


export const noData = (data) => {
  return (
    <div className="commingSoon">
      <div>
        <img src="assets/img/commingSoon.svg" alt="" />
        <p>{data}</p>
      </div>
    </div>
  )
}

export const getId = (obj) => {
  return obj?.id || obj?._id || obj?.userId || null;
}

export default function UserProfile({ setShowProfile, conversation, participants, currentUserId, channelList, setSelected, onRename }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { isChatLoading, chatMedia, chatMediaFileName, chatMediaDocs, loadingChatMediaFile } = useSelector((state) => state.chat);
  const [editConvoTrigger, setEditConvoTrigger] = useState(false);
  const [editConvo, setEditConvo] = useState("");
  const [messageModal, setMessageModal] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [previewFileTabChange, setPreviewFileTabChange] = useState(null);
  const [setNewChat, setNewChatTrigger] = useState(false);

  useEffect(() => {
    const changedChannelTrigger = async () => {
      if (currentUserId) {
        dispatch(chatMediaGetAction(currentUserId))
      }
    }
    changedChannelTrigger()
  }, [currentUserId, dispatch])

  var sidebarList = [
    // {
    //   id: 1,
    //   img: "assets/img/Sign.svg",
    //   name: "Sign document",
    // },
    {
      id: 2,
      img: "assets/img/addUser.svg",
      name: "Chat members",
    },
    // {
    //   id: 3,
    //   img: "assets/img/paymentIcon.svg",
    //   name: "Payments",
    // },
    {
      id: 4,
      img: "assets/img/viewFile.svg",
      name: "View files",
    },
    // {
    //   id: 5,
    //   img: "assets/img/addNewTask.svg",
    //   name: "Add new task",
    // },
  ];


  const showFilteredAddPeople = (item, index) => {
    return (
      <div
        key={index}
        className="col-lg-12 inner-section"
      >
        <div
          className="profile-img"
          style={{
            backgroundImage: `url(${item &&
              item?.image
              ? backendUrl + item?.image
              : "assets/img/Frame1.svg"
              })`,
          }}
        ></div>
        <div className="profile-name">
          {item?.first_name + " " + item?.last_name}
        </div>
      </div>
    )
  }
  return (
    <>
      <>
        <div className="profile-header">
          <button
            type="button"
            className="btn-close text-dark close-button"
            onClick={() => setShowProfile(false)}
          ></button>


          <div
            style={{
              backgroundImage: `url(${getChatUserImage(
                participants,
                user
              )})`,
            }}
            className="profile_photo">
          </div>


          <div className="userInfo">
            {(participants?.length > 2 && (editConvoTrigger) ? (
              <h5>
                <input className="editConvoInput" type="text" name="" onChange={(e) => setEditConvo(e.target.value)} value={editConvo} /> &nbsp;
                <span onClick={() => { onRename(editConvo); setEditConvoTrigger(false); }} className="editConvo"><i className="fa fa-check" aria-hidden="true"></i></span>&nbsp;&nbsp;
                <span onClick={() => setEditConvoTrigger(false)} className="editConvo"><i className="fa fa-close" aria-hidden="true"></i></span>
              </h5>
            ) : (
              <h5>
                <div>{getName(conversation, user)}</div>
                {participants?.length > 2 && (
                  <span onClick={() => { setEditConvoTrigger(true); setEditConvo(getName(conversation, user)) }} className="editConvo">
                    <i className="fa fa-pencil-square" aria-hidden="true"></i>
                  </span>
                )}
              </h5>
            ))}
            {/* {printCompanyName(conversation?.attributes)} */}
            <p className="time">
              {moment().format("h:mm") + " GMT" + moment().format("Z")}&nbsp;
            </p>
          </div>
        </div>

        <div className="profile-body">
          <ul>
            <>
              <Accordion>
                {sidebarList.map((item, index) => (
                  <Accordion.Item
                    className={activeAccordion === index ? 'listHolder active' : 'listHolder'}
                    key={index}
                    eventKey={index}
                  >

                    <Accordion.Header onClick={() => setActiveAccordion(activeAccordion === index ? null : index)}>
                      <li>
                        <img src={item.img} className="icon" alt="" />
                        <p>{item.name}</p>
                        <div className="arrowIcon rotateArrow">
                          <img src="assets/img/profileArrow.svg" alt="" />
                        </div>
                      </li>
                    </Accordion.Header>

                    <Accordion.Body>
                      {
                        item.id === 2 ? (
                          <>
                            <h5 className="partitipantMemberCountHead">Chat Members ({participants?.length})</h5>
                            <div className={`row ${participants && participants?.length > 0 ? 'conversation-section customScroll' : ''}`}>
                              {participants &&
                                participants?.length > 0 ? (
                                participants.map((item, index) => (
                                  showFilteredAddPeople(item, index)
                                ))
                              ) : (
                                noData("No people to add...")
                              )}
                            </div>
                            <button onClick={() => setMessageModal(true)} type="button" className="btn card-btn add-morepeople-bottom-btn mb-0">Manage people</button>
                          </>
                        ) : (item.id === 4) ? (
                          loadingChatMediaFile ? noData("Loading please wait ...") : (
                            // chatMedia.length > 0 ? (
                            <>

                              <Tabs onSelect={(index) => setPreviewFileTabChange(index)}>
                                <TabList>
                                  <Tab>Images</Tab>
                                  <Tab>Documents</Tab>
                                </TabList>
                                <TabPanel>
                                  <ChatImagePreviewer type="image" chatMedia={chatMedia} dispatch={dispatch} previewFileTabChange={previewFileTabChange} />
                                </TabPanel>
                                <TabPanel>
                                  <ChatImagePreviewer type="other" chatMedia={chatMediaDocs} dispatch={dispatch} previewFileTabChange={previewFileTabChange} />
                                </TabPanel>
                              </Tabs>

                            </>
                            // ) : (
                            //   noData("No attached files...")
                            // )
                          )
                        ) : (
                          <div className="commingSoon">
                            <div>
                              <img src="assets/img/commingSoon.svg" alt="" />
                              <p>Coming soon...</p>
                            </div>
                          </div>
                        )
                      }
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </>
            <li className="flex-li">
              <div className="row">
                <div className="col-12">
                  <button onClick={() => [setMessageModal(true), setNewChatTrigger(true)]} type="button" className="btn card-btn add-morepeople-bottom-btn mb-0">Start new chat</button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </>
      <ManagePeople
        currentConvoSid={currentUserId}
        newChat={setNewChat ? true : false}
        setNewChat={setNewChat}
        participants={setNewChat ? [] : participants}
        messageModal={messageModal}
        addModalClose={() => [setMessageModal(false), setNewChatTrigger(false)]}
        setSelected={setSelected}
      />
    </>
  );
}
